import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import useForm from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from '@material-ui/core';

const ListEstablishment = (props) => {
  const { displayOptions } = props;
  const { attributes, actions, listEstablishment, findAllEstablishment, establishmentIsActivited, setEstablishmentIsActivited, region, setRegion, totalPages, loading, query } = useForm(displayOptions);

  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={t('establishment.title.list')}
            subtitle={t('establishment.subTitle')}
            className="text-sm-left"
          />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <Table
                attributes={attributes}
                actions={actions}
                data={listEstablishment}
                loading={loading}
                search={findAllEstablishment}
                establishmentIsActivited={establishmentIsActivited}
                setEstablishmentIsActivited={setEstablishmentIsActivited}
                region={region}
                setRegion={setRegion}
                numberOfPage={totalPages}
                query={query}
                name={'establishment'}
                textButton={displayOptions.addButton && t('establishment.add')}
                linkButton={displayOptions.addButton && '/establishment/add'}
                pdfTitle="Liste des établissements"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListEstablishment;
